// Resolves a business logo value into an absolute, usable <img src>.
// Uploaded logos are stored as "/api/business/logo/<path>"; users may also paste
// a full external URL. Either way this returns something an <img> can load.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const abs = (v) => {
  if (!v) return null;
  if (/^https?:\/\//i.test(v) || v.startsWith("data:")) return v;
  if (v.startsWith("/api/")) return `${BACKEND}${v}`;
  return v;
};

export const logoSrc = (business) => abs(business?.logo_url);
export const thermalLogoSrc = (business) => abs(business?.logo_thermal_url) || abs(business?.logo_url);
